;(function() {
/* @ngInject */
function ModalLegislationInfo($uibModal, $rootScope) {
  let title;
  let text;

  return function init(title_, text_) {
    title = title_;
    text = text_;

    return { add };
  };

  function open(options = {}) {
    return $uibModal.open(angular.extend({
      templateUrl: "/app/shared/modal-legislation-info/modal-legislation-info.html",
      controller: "ModalLegislationInfoController",
      controllerAs: "vm",
      bindToController: true,
      backdrop: "static",
      resolve: {
        title: () => title,
        text: () => text
      },
      size: "md"
    }, options));
  }

  function add(scope = {}) {
    return open({ scope: angular.extend($rootScope.$new(true), scope) });
  }
}

/* @ngInject */
function ModalLegislationInfoController($uibModalInstance, title, text) {
  let vm = this;

  vm.title = title;
  vm.text = text;
  vm.close = () => $uibModalInstance.close("cancel");
}

angular.module("firmaren")
  .factory("ModalLegislationInfo", ModalLegislationInfo)
  .controller("ModalLegislationInfoController", ModalLegislationInfoController);
}());
